import ContentsBase from './ContentsBase';
import { formatUTCDate, parseUTCDate } from "../../../utils/FPEUtils";
import LegendSatCld from "../legend/LegendSatCld";
import { WX_ID_SATELLITE } from "../../../store/WeatherContentsState";

class SatCld extends ContentsBase {
  static NAME = WX_ID_SATELLITE;
  static TIME_RANGE = 5 * 60 * 60 * 1000;
  prevValidtime;
  setRevision;
  constructor(setRevision) {
    super('SAT CLD', 'SAT_CLD', 'WNI_ANLSIS_SAT_WORLD_CLDTOP');
    this.setRevision = setRevision;
  }

  parseTimelist() {
    const validtime = this.dataReference.query("validtime").value();
    this.validtimeList = this.filterValid(validtime, SatCld.TIME_RANGE);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataValid()) {
        this.setRevision();
      }
    }
    this.prevValidtime = [...this.validtimeList];
  }

  getOpt(validtime) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForValid(validtime);
        return {
          SAT_CLD: {
            Validtime: this.shownTime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: SatCld.NAME,
      label: 'SAT CLD',
      component: LegendSatCld,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: SatCld.NAME,
      label: 'SAT CLD',
      baseTime: this.shownTime ? formatUTCDate(parseUTCDate(this.shownTime), '%Y/%m/%d %H:%MZ') : "---"
    }
  }
}

export default SatCld;